<script lang="ts">
  import Skeleton from "./Skeleton.svelte";
  import Stack from "../Stack.svelte";
</script>

<div class="container">
  <div class="date" />

  <Stack vertical padding="10px 16px" alignItems="stretch">
    <div class="row">
      <Skeleton --skeleton-height="12px" --skeleton-width="60%" --skeleton-radius="2px" />
    </div>
    <Skeleton --skeleton-height="12px" --skeleton-width="35%" --skeleton-radius="2px" />
  </Stack>
</div>

<style>
  .container {
    display: flex;
    flex: 1;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }

  .date {
    width: 48px;
    height: 56px;
    border: solid 1px var(--rk-divider-0);
    border-radius: 6px;
  }

  .row {
    padding-bottom: 12px;
  }
</style>
